const giftingCheckbox = document.getElementById( 'gift_this_order' );
const cartNote = document.getElementById('cart-note');
const cartNoteTextareaEl = document.querySelector( '#note' );
const cardsSlider = document.getElementById( 'cart-collection-cards' );
const carouselEl = document.querySelector( '.products-carousel' );
const cardCheckEl = document.querySelector( '#premium-card-check' );
const yesPremiumCardLabelEl = document.querySelector( '#yes-premium-card' );
const noPremiumCardLabelEl = document.querySelector( '#no-premium-card' );
const addMessageCardEl = document.querySelector('#add-message-card');
const addMessageContainerEl = document.querySelector( '#add-message' );
const carouselItemLinkEls = document.querySelectorAll( '.carousel-cell' );
const carouselSelectedItemLinkEl = document.querySelector( '.carousel-cell.added-to-cart' );
const cartTotalTextEl = document.querySelector( '#cart-total-final-price .money' );
const cartSubmitEl = document.querySelector( '#cart_submit' );
const proceedNoteEl = document.querySelector( '#proceed-note' );
let flickityOptions = {
    "prevNextButtons": true,
    "pageDots": false,
    "contain": true,
    "cellAlign": "left",
    "groupCells": true,
    "arrowShape": {"x0": 20, "x1": 60, "y1": 40, "x2": 60, "y2": 35, "x3": 25}
};
var Shopify = Shopify || {};
// ---------------------------------------------------------------------------
// Money format handler
// ---------------------------------------------------------------------------
Shopify.money_format = "${{amount}}";
Shopify.formatMoney = function(cents, format) {
  if (typeof cents == 'string') { cents = cents.replace('.',''); }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = (format || this.money_format);

  function defaultOption(opt, def) {
     return (typeof opt == 'undefined' ? def : opt);
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal   = defaultOption(decimal, '.');

    if (isNaN(number) || number == null) { return 0; }

    number = (number/100.0).toFixed(precision);

    var parts   = number.split('.'),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        cents   = parts[1] ? (decimal + parts[1]) : '';

    return dollars + cents;
  }

  switch(formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }

  return formatString.replace(placeholderRegex, value);
};
function createInsertHTML( data, row_count ){
    const trEl = document.createElement( 'tr' );
    trEl.setAttribute( 'class','even line-item id-'+ data.variant_id );

    // Image TD
    const tdCartImageEl = document.createElement( 'td' );
    const aCartImageEl = document.createElement( 'a' );
    const divCartImageEl = document.createElement( 'div' );
    const imgCartEl = document.createElement('img');
    tdCartImageEl.setAttribute( 'class', 'cart-table-image' );
    aCartImageEl.setAttribute( 'class','cart_thumb' );
    aCartImageEl.setAttribute( 'href', data.url );
    aCartImageEl.setAttribute( 'title', data.title );
    divCartImageEl.style.position = 'relative';
    imgCartEl.setAttribute( 'src', data.image );
    imgCartEl.setAttribute( 'class', 'lazyautosizes lazyloaded' );
    imgCartEl.setAttribute( 'data-sizes', 'auto' );
    imgCartEl.setAttribute( 'data-aspectratio', '1.5' );
    imgCartEl.setAttribute( 'data-blur', 'true' );
    imgCartEl.setAttribute( 'alt', '' );
    imgCartEl.setAttribute( 'sizes', '223px' );

    divCartImageEl.appendChild( imgCartEl );
    aCartImageEl.appendChild( divCartImageEl );
    tdCartImageEl.appendChild( aCartImageEl );

    // Details TD
    const tdDetailEl = document.createElement('td');
    const aDetailEl = document.createElement( 'a' );
    const divDetailEl = document.createElement( 'div' );
    const aRemoveItemEl = document.createElement( 'a' );
    tdDetailEl.setAttribute( 'class', 'cart-table-title' );
    aDetailEl.setAttribute( 'class', 'cart-table-title__title' );
    aDetailEl.setAttribute( 'href', data.url );
    aDetailEl.setAttribute( 'title', data.title );
    aDetailEl.textContent = data.title;
    divDetailEl.setAttribute( 'class', 'cart-table-item-remove' )
    aRemoveItemEl.setAttribute( 'href', '/cart/change?line=' + row_count + '&amp;quantity=0' )
    aRemoveItemEl.textContent = 'Remove';

    divDetailEl.appendChild( aRemoveItemEl );
    aDetailEl.appendChild( divDetailEl );
    tdDetailEl.appendChild( aDetailEl );

    // Price TD
    const tdPriceEl = document.createElement( 'td' );
    const spanPriceEl = document.createElement( 'span' );
    tdPriceEl.setAttribute( 'class', 'cart-table-price' );
    spanPriceEl.setAttribute( 'class','money' );
    spanPriceEl.textContent = Shopify.formatMoney( data.price );

    tdPriceEl.appendChild( spanPriceEl );


    // Quantity TD
    const tdQuantityEl = document.createElement( 'td' );
    const divQuantityContolEl = document.createElement( 'div' );
    const btnQuantityMinusEl = document.createElement( 'button' );
    const btnQuantityPlusEl = document.createElement( 'button' );
    const spanQuantityCountEl = document.createElement( 'span' );
    const inputQuantityCountEl = document.createElement( 'input' );
    tdQuantityEl.setAttribute( 'class', 'cart-table-quantity' );
    divQuantityContolEl.setAttribute( 'class', 'quantity-controls remove-border card-ajax-added' );
    //btnQuantityMinusEl.setAttribute( 'type','button' );
    //btnQuantityMinusEl.setAttribute( 'class','qty-minus alt-focus' );
    //btnQuantityMinusEl.setAttribute( 'aria-label', 'Reduce item quantity by one' );
    //btnQuantityMinusEl.textContent = '-';
    //inputQuantityCountEl.setAttribute('id','updates_'+ data.variant_id);
    //inputQuantityCountEl.setAttribute('class','number quantity-selector');
    //inputQuantityCountEl.setAttribute('type','text');
    spanQuantityCountEl.textContent = 1;
    spanQuantityCountEl.setAttribute( 'class', 'number item-count' );
    //inputQuantityCountEl.setAttribute('size','4');
    //inputQuantityCountEl.setAttribute('name','updates[' + data.variant_id + ']');
    //btnQuantityPlusEl.setAttribute( 'type','button' );
    //btnQuantityPlusEl.setAttribute( 'class','qty-plus alt-focus' );
   // btnQuantityPlusEl.setAttribute( 'aria-label', 'Increase item quantity by one' );
    //btnQuantityPlusEl.textContent = '+';
    
    //divQuantityContolEl.appendChild( btnQuantityMinusEl );
    //divQuantityContolEl.appendChild( inputQuantityCountEl );
    divQuantityContolEl.appendChild( spanQuantityCountEl );
    //divQuantityContolEl.appendChild( btnQuantityPlusEl );
    tdQuantityEl.appendChild( divQuantityContolEl );

    // Total TD
    const tdTotalEl = document.createElement('td');
    const spanTotalPriceEl = document.createElement( 'span' );
    tdTotalEl.setAttribute( 'class', 'cart-table-line-price cart--final-column' );
    spanPriceEl.setAttribute( 'class','money' );
    spanTotalPriceEl.textContent = Shopify.formatMoney( data.final_price );

    tdTotalEl.appendChild( spanTotalPriceEl );

    // Append children
    trEl.appendChild( tdCartImageEl );
    trEl.appendChild( tdDetailEl );
    trEl.appendChild( tdPriceEl );
    trEl.appendChild( tdQuantityEl );
    trEl.appendChild( tdTotalEl );

    return trEl;
}

/** INIT CARDS CAROUSEL **/
cardsCarousel = new Flickity( carouselEl,flickityOptions );

/** 
  THIS IS A GIFT ON CHANGE EVENT 
**/
giftingCheckbox.addEventListener('change',function(event){
  if(event.currentTarget.checked){
    addMessageContainerEl.style.display = 'block';
    
    
  }else{
    cartNote.style.display = 'none';
    cardsSlider.style.display = 'none';
    addMessageContainerEl.style.display = 'none';
    cartNoteTextareaEl.value = '';
    addMessageCardEl.checked = false;
  }
});
/** 
  ADD CUSTOM MESSAGE
**/
addMessageCardEl.addEventListener('change',function(event){
  if(event.currentTarget.checked){
    cartNote.style.display = 'block';
    cartNoteTextareaEl.setAttribute( 'required', '' );
    cardsSlider.style.display = 'block';
    cardsCarousel.resize();
        proceedNoteEl.style.display = 'block';
    cartSubmitEl.setAttribute( 'disabled','' );
  }else{
    cardsSlider.style.display = 'none';
    cartNoteTextareaEl.value = '';
    cartNote.style.display = 'none';
    cardsSlider.style.display = 'none';
    proceedNoteEl.style.display = 'none';
    cartSubmitEl.removeAttribute( 'disabled' );
  }
});
/**
  CARD TYPE ON CHANGE EVENT
**/
// yesPremiumCardLabelEl.addEventListener( 'change',function( event ){
//   if( event.currentTarget.checked ){
//     cardsSlider.style.display = 'block';
//     cardsCarousel.resize();
//   }
// } );
// noPremiumCardLabelEl.addEventListener( 'change',function( event ){
//   if( event.currentTarget.checked ){
//     cardsSlider.style.display = 'none';
//   }
// } );

/** ADD TO CART IN THE CART PAGE **/
[...carouselItemLinkEls].forEach( ( carouselItemLinkEl ) =>{
  carouselItemLinkEl.addEventListener( 'click',function( event ){
    event.preventDefault();
    [...carouselItemLinkEls].forEach( otherCarouselItemEl => {
        otherCarouselItemEl.classList.remove( 'added-to-cart' );
    } );
    let itemID = carouselItemLinkEl.getAttribute( 'data-variant-id' );
    carouselItemLinkEl.classList.add( 'added-to-cart' );
    let addItemsData = {
     'items': [{
      'id':  parseInt(itemID),
      'quantity': 1
      }]
    };
    // Add items to cart
    fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(addItemsData)
      })
      .then(response => {
        return response.json();
      })
      .then( data => {
        let row_count = document.querySelectorAll( '.cart-table tbody tr' ).length;
        let itemsTotalPrice = 0;
        data.items.forEach( item => {
          document.querySelector( '.cart-table tbody').appendChild( createInsertHTML( item, row_count ) );
          row_count++;
        } );
        proceedNoteEl.style.display = 'none';
        cartSubmitEl.removeAttribute( 'disabled' );
        fetch( window.Shopify.routes.root + 'cart.js',{ method: 'GET'} )
          .then( cartresponse => {
            return cartresponse.json();
          } )
          .then( cartdata => {
            console.log( cartdata );
            cartTotalTextEl.innerText = Shopify.formatMoney( cartdata.items_subtotal_price );
          });
      })
      .catch((error) => {
        console.error('Error:', error);
      });
    // Pull cart data
    
  } );
} );